export const MAP_RATIO = 2000 / 1413;

// Rasterposities in % van de kaart, startend op (x0,y0); horizontale en verticale afstand optisch gelijk
export function gridPositions(x0, y0, n, pct = 0.024, cols = 6) {
  const stepX = pct * 100 + 0.4;
  const stepY = stepX * MAP_RATIO;
  const out = [];
  for (let i = 0; i < n; i++) {
    const c = i % cols;
    const r = Math.floor(i / cols);
    out.push({
      x: Math.max(1, Math.min(99, Math.round((x0 + c * stepX) * 100) / 100)),
      y: Math.max(1, Math.min(99, Math.round((y0 + r * stepY) * 100) / 100)),
    });
  }
  return out;
}
